import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectIsAuth, selectProfile } from '@/store/profile.reducer'
import websocket from '@/utils/websocket'

const WebSocketConnectionAlertBridge = () => {
  const isAuth = useSelector(selectIsAuth)
  const userId = useSelector(selectProfile)?.id
  useEffect(() => {
    if (!isAuth || !userId) {
      websocket.disconnect()
      return undefined
    }

    websocket.connect()
    return () => websocket.disconnect(false)
  }, [isAuth, userId])

  return null
}

export default WebSocketConnectionAlertBridge
